import getMuiTheme from 'material-ui/styles/getMuiTheme';

const theme = getMuiTheme({});

export default theme;



// WEBPACK FOOTER //
// ./src/theme.js